import { styled } from '../jss-style';
import emptyStyle from './empty';

const useEmptyStyle = styled(emptyStyle, 'empty');

export { emptyStyle, useEmptyStyle };
export default useEmptyStyle;
